var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { CasesTable } from './sections/CasesTable/CasesTable';
import CasesListFilters from './sections/CasesListFilters';
import { Pagination } from './sections/Pagination/Pagination';
import { useRouter } from 'src/shared/hooks/useRouting';
import { getPropsByKeyPath, objToBase64 } from 'src/shared/helpers/objHelpers';
import { changeQueryParams } from 'src/shared/helpers/urlHelpers';
import { E_BROADCAST_MESSAGE, listenToBroadcast } from 'src/shared/helpers/browserHelpers';
import { E_SNACKBAR_TYPE } from 'src/ui/components/SnackBar/SnackBar';
import { IMAGES_TO_CACHE, URL_PATH } from 'src/shared/constants';
import { useUnmount } from 'src/shared/hooks/useLifecycle';
import { changeFavicon } from 'src/shared/helpers/pagesHelpers';
import './cases.scss';
export var Cases = function (props) {
    var i18n = props.i18n, cases = props.cases, isCasesLoading = props.isCasesLoading, filters = props.filters, allColumns = props.allColumns, visibleColumns = props.visibleColumns, isNotificationsActivated = props.isNotificationsActivated, isAutoPlay = props.isAutoPlay, fetchCasesRequested = props.fetchCasesRequested, updateFilters = props.updateFilters, updateColumnRequested = props.updateColumnRequested, exportCasesInCSV = props.exportCasesInCSV, updateIsNotificationsActivated = props.updateIsNotificationsActivated, addNotification = props.addNotification;
    var routerEnhanced = useRouter();
    var collection = cases.collection, nbOfPages = cases.nbOfPages, nbByPage = cases.nbByPage, currentPages = cases.currentPages, total = cases.total;
    var _a = useState(isNotificationsActivated), isNotificationActivated = _a[0], setNotificationActivated = _a[1];
    useUnmount(function () {
        changeFavicon(IMAGES_TO_CACHE.FAVICON);
    });
    useEffect(function () {
        var caseFetchingInterval = null;
        if (isNotificationActivated) {
            caseFetchingInterval = setInterval(function () { return fetchCasesRequested(); }, 1000 * 10); // 10 seconds
            fetchCasesRequested();
            updateIsNotificationsActivated(true);
            var broadcastCloser_1 = listenToBroadcast(E_BROADCAST_MESSAGE.DISCONNECT, function () {
                addNotification({
                    type: E_SNACKBAR_TYPE.ERROR,
                    description: getPropsByKeyPath(i18n.keyValueMap, 'notifications.error.disconnect'),
                    withNotification: true,
                    cancellable: true,
                });
            });
            // return to close broadcast channel when component is unmounted or when isNotificationActivated change
            return function () {
                clearInterval(caseFetchingInterval);
                broadcastCloser_1();
            };
        }
        else {
            updateIsNotificationsActivated(false);
        }
        return function () { return clearInterval(caseFetchingInterval); };
    }, [isNotificationActivated]);
    useEffect(function () {
        if (filters) {
            changeQueryParams({ filter: objToBase64(filters) });
            fetchCasesRequested();
        }
    }, [filters]);
    var handleOnCaseClick = function (doc) {
        routerEnhanced.push(URL_PATH.CASE_DETAIL_WITHOUT_PRODUCT(doc.id));
    };
    var handleOnPageChange = function (newPage) {
        updateFilters({ offset: (newPage - 1) * nbByPage });
    };
    var handleOnResultsPerPageChange = function (count) {
        updateFilters({ count: count, offset: 0 });
    };
    var handleOnHeadClick = function (headLabel) {
        var keyMapForValue = visibleColumns.find(function (col) { return col.label === headLabel; }).keyMapForValue;
        var keyMapParsed = keyMapForValue[0].source.replace('data.', '');
        var isCurrentSort = filters.sortFields[0].field === keyMapParsed;
        var sortQuery = { field: keyMapParsed, ascending: isCurrentSort ? !filters.sortFields[0].ascending : true };
        updateFilters({ sortFields: [sortQuery] });
    };
    var handleOnRefresh = function () {
        fetchCasesRequested();
    };
    return (_jsxs("section", __assign({ className: 'casesWrapper' }, { children: [_jsx(CasesListFilters, { allColumns: allColumns, isNotificationActivated: isNotificationActivated, onNotificationChange: function () { return setNotificationActivated(!isNotificationActivated); }, onRefresh: handleOnRefresh, visibleColumns: visibleColumns, onColumnsChange: updateColumnRequested, onExport: exportCasesInCSV }), _jsxs("div", __assign({ className: 'tableWrapper' }, { children: [_jsx(CasesTable, { i18n: i18n, cases: collection, columns: visibleColumns, currentSort: filters === null || filters === void 0 ? void 0 : filters.sortFields[0], isLoading: isCasesLoading, onCaseClick: handleOnCaseClick, onHeadClick: handleOnHeadClick }), _jsx(Pagination, { i18n: i18n, total: total, nbByPage: nbByPage, nbOfPages: nbOfPages, currentPage: currentPages, onPageChange: handleOnPageChange, onResultsPerPageChange: handleOnResultsPerPageChange })] }))] })));
};
